import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enTranslations from './locales/en.json';
import esTranslations from './locales/es.json';
import frTranslations from './locales/fr.json';
import deTranslations from './locales/de.json';
import itTranslations from './locales/it.json';
import ptTranslations from './locales/pt.json';
import ruTranslations from './locales/ru.json';
import zhCNTranslations from './locales/zh-CN.json';
import jaTranslations from './locales/ja.json';
import koTranslations from './locales/ko.json';
import arTranslations from './locales/ar.json';
import hiTranslations from './locales/hi.json';

const resources = {
  en: { translation: enTranslations },
  es: { translation: esTranslations },
  fr: { translation: frTranslations },
  de: { translation: deTranslations },
  it: { translation: itTranslations },
  pt: { translation: ptTranslations },
  ru: { translation: ruTranslations },
  'zh-CN': { translation: zhCNTranslations },
  ja: { translation: jaTranslations },
  ko: { translation: koTranslations },
  ar: { translation: arTranslations },
  hi: { translation: hiTranslations },
};

// Initialize i18n synchronously with localStorage language
const getInitialLanguage = () => {
  if (typeof window !== 'undefined' && window.localStorage) {
    const savedLanguage = localStorage.getItem('language');
    if (savedLanguage && resources[savedLanguage]) {
      return savedLanguage;
    }
  }
  return 'en';
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: getInitialLanguage(), // Set initial language immediately
    fallbackLng: 'en',
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      // Order of detection methods
      order: ['localStorage', 'navigator'],
      // Keys to lookup language from
      lookupLocalStorage: 'language',
      // Cache user language
      caches: ['localStorage'],
    },
    react: {
      useSuspense: false, // Disable suspense for better compatibility
    },
    initImmediate: true, // Initialize immediately
  });

export default i18n;

